import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .ABSChipContainer': {
    display: 'flex',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 4,
    border: '1px solid',
    borderColor: theme.palette.divider[7],
    padding: theme.spacing(0.5, 0.25),
    marginRight: theme.spacing(1),
  },
  '& .ABSChip': {
    padding: theme.spacing(1.25, 1.75, 1.15),
    borderRadius: 4,
    backgroundColor: 'transparent',
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '150%',
    fontWeight: 500,
    height: theme.typography.pxToRem(38),
    margin: theme.spacing(0, 0.25),

    '&.ABSChip-selected': {
      backgroundColor: theme.palette.background.tertiary,
    },
  },
  '& .ABSLocationAC': {
    width: theme.typography.pxToRem(170),
    backgroundColor: theme.palette.secondary.main,
     [theme.breakpoints.down('md')]: {
       width: '100%'
     },
    '& .MuiInputBase-root.MuiInputBase-formControl': {
      paddingTop: theme.typography.pxToRem(5.5),
      paddingBottom: theme.typography.pxToRem(4.5),
      paddingRight: theme.spacing(3.25),
        '& svg':{
         fontSize: theme.typography.pxToRem(16),
      },
    },
    '& .MuiOutlinedInput-notchedOutline' : {
      borderColor: `${theme.palette.divider[7]} !important`,

    },
    '& .MuiInputBase-input,.MuiInputBase-input.MuiAutocomplete-input': {
      padding: theme.spacing(1.1, 0.5, 0.80, 0.5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '150%',
      fontWeight: 600,
    
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 11px)',
    },
  },
  '& .ABSNoBikesContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(16, 0),
    backgroundColor: theme.palette.background.secondary,
  },
  '& .ABSCreditsTextField': {
    '&  .MuiInputBase-input': {
      paddingTop: theme.typography.pxToRem(8),
      paddingBottom: theme.typography.pxToRem(6),
      borderColor: theme.palette.divider[7],
    },
    '& .MuiInputBase-root.MuiInputBase-formControl': {
      paddingRight: 'inherit',
    },
  },
  '& .ABSFilterContainer': {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
     [theme.breakpoints.down('md')]: {
       width: '100%',
        gap: theme.spacing(1),
     },
   
  },
  '& .ABSInputContainer':{
     [theme.breakpoints.down('md')]: {
       width: '50%'
     },
  },
}));
export default StyledBox